import { IApplicationState } from "redux/root-reducer";
import { useSelector } from "react-redux";

export const useDomainNumberFormatter = () => {
  const { Currency: currency, DefaultCulture: locale } = useSelector(
    (state: IApplicationState) => state.common.currentUserInfo.DomainSettings
  );

  const formatNumber = (value: number) => {
    return new Intl.NumberFormat(locale, {
      style: "decimal",
      currency,
    }).format(value);
  };

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(value);
  };

  return {
    formatNumber,
    formatCurrency,
  };
};
